import { defaultState } from "./types";
import { InspectorContext, reducer } from "./reducer";
import { MainInterface } from "./components/MainInterface";
import { OperationSelection } from "./components/OperationSelection";
import { useReducer } from "react";
import { WeldSelection } from "./components/WeldSelection";
import { usePageStateGuard } from "@/hooks";

export function HitachiInspectorRole() {
  const [state, updateState] = useReducer(reducer, defaultState);
  const currentPage = usePageStateGuard({
    2: Boolean(state.operation),
    3: Boolean(state.operation) && state.welds.length > 0,
  });

  return (
    <InspectorContext.Provider value={{ state, updateState }}>
      {currentPage === 1 && <OperationSelection />}
      {currentPage === 2 && <WeldSelection />}
      {currentPage === 3 && <MainInterface />}
    </InspectorContext.Provider>
  );
}
